import type { PostHog } from 'posthog-js';

import { safeCapture } from './analytics';

/** Dashboard-wide outcome signals that complement detailed onboarding events. */
export const DASHBOARD_PLG_EVENTS = {
  WORKSPACE_VIEWED: 'dashboard_workspace_viewed',
  FORM_PUBLISHED: 'form_published',
  CONTACT_CREATED: 'contact_created',
  TEAM_INVITES_SENT: 'team_invites_sent',
  BROADCAST_STARTED: 'broadcast_started',
  // PE-1766 — an org clicked "Request this feature" on the coming-soon-with-
  // Pro teaser for a dedicated SMS sending number. Demand signal for Pro
  // pricing/launch: count DISTINCT organization_id on this event to size
  // interest before Pro is published.
  PRO_SMS_NUMBER_INTEREST: 'pro_sms_number_interest_requested',
} as const;

export function dashboardWorkspaceFromPath(pathname: string): string {
  if (pathname === '/' || pathname.startsWith('/home')) return 'home';
  if (pathname.startsWith('/forms') || pathname.startsWith('/fundraisers')) return 'forms';
  if (pathname.startsWith('/elements')) return 'elements';
  if (pathname.startsWith('/broadcasts')) return 'broadcasts';
  if (pathname.startsWith('/segments')) return 'segments';
  if (pathname.startsWith('/brand-kit')) return 'brand_kit';
  if (pathname.startsWith('/contacts') || pathname.startsWith('/donors')) return 'contacts';
  if (pathname.startsWith('/payments') || pathname.startsWith('/donations')) return 'payments';
  if (pathname.startsWith('/subscriptions')) return 'subscriptions';
  if (pathname.startsWith('/payouts')) return 'payouts';
  if (pathname.startsWith('/settings')) return 'settings';
  return 'other';
}

export function dashboardWorkspaceViewKey(organizationId: string, pathname: string): string {
  return `${organizationId}:${dashboardWorkspaceFromPath(pathname)}`;
}

export type DashboardPlgEvent =
  (typeof DASHBOARD_PLG_EVENTS)[keyof typeof DASHBOARD_PLG_EVENTS];

export function trackDashboardPlg(
  posthog: PostHog | undefined,
  event: DashboardPlgEvent,
  properties: Record<string, unknown> = {},
): void {
  safeCapture(posthog, event, properties);
}
